const closeDonateMenu = () => {
    const activeItems = document.querySelectorAll('.donate-menu__item--active');

    activeItems.forEach(item => {
        item.classList.remove('donate-menu__item--active');

        const link = item.querySelector('a');
        if (link && link.dataset.originalText) {
            link.textContent = link.dataset.originalText;
        }
    });
};

const MobileMenu = () => {
    // close the donate menu whenever the mobile menu gets opened
    const mobileToggle = document.querySelector('.header__mobile');

    if (mobileToggle) {
        mobileToggle.addEventListener('click', () => {
            // If donate menu is open → close it
            const donateActive = document.querySelector('.donate-menu__item--active');

            if (donateActive) {
                closeDonateMenu();
            }
        });
    }

    // Fetch all mobile menu items
    let items = document.querySelectorAll('.mobile-menu__item--parent');

    // Loop through all menu items that contain submenus
    Array.from(items).forEach(item => {
        // Locate the arrow wrapper which will essentially be the trigger for this menu
        // opening and closing
        let arrow = item.querySelector('.mobile-menu__arrow-wrap');

        // If we have an arrow, proceed
        if (typeof arrow != 'undefined' && arrow != null) {
            // Add event listened for when the user clicks on the <li>
            arrow.addEventListener('click', () => {
                // If the <li> already has the active class
                if (item.matches('.mobile-menu__item--active')) {
                    // Remove the active class
                    item.classList.remove('mobile-menu__item--active');
                } else {
                    // Add the active class
                    item.classList.add('mobile-menu__item--active');
                }
            });
        }
    });
};

export default MobileMenu;
